import { createI18n, I18n } from 'vue-i18n';
import { useConfigStore } from '../stores/config';
import messages from '@intlify/unplugin-vue-i18n/messages';

export const initI18n = (): I18n => {
  const configStore = useConfigStore();
  return createI18n({
    legacy: false,
    globalInjection: true,
    locale: configStore.locale.split('-')[0],
    fallbackLocale: 'en',
    messages: messages,
  });
};
